import type { AvailableLocale } from '@ianesthesie-kit/config';

export * from './appConfig.service';
export * from './appTheme';
export * from './dialogMap';
export * from './routes';
export * from './permissions';
export * from './mutationCacheKeys';

export const availableLocales: AvailableLocale[] = ['en', 'fr'];
